import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import ErrorImage from 'shared/images/error_handler.png'
import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

type Props = {
  text: string | undefined
}

export const DialogScanPassportError = ({ text }: Props) => {
  const { t } = useTranslation()

  const { closeDialog } = useDialogBottomSheet()

  return (
    <div className={s.dialog_scan_passport_error}>
      <ImageLazy
        src={ErrorImage}
        alt="error"
        className={s.image}
      />
      <div className={s.text}>
        <h3 className={clsx(s.title, 'bold-20')}>
          {t('scan_passport.scan_error')}
        </h3>

        <p className={clsx(s.description, 'regular-14')}>{text}</p>
      </div>

      <Button onClick={closeDialog}>
        <span className={clsx(s.text, 'semi-bold-17')}>{t('close')}</span>
      </Button>
    </div>
  )
}
